import { AbstractControl, ValidationErrors } from '@angular/forms';

export class MaskedPhoneNumberError {
  phoneNumberLength: boolean;
}
// this function validates the conformation code entered by user
export function MaskedPhoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  let value = control.value;
  const phoneNumberError = new MaskedPhoneNumberError();
  let valid = true;
  if (value) {
    value = value.replace(/\-/g, '');
    value = value.replace(/\_/g, '');
    if (value.length !== 10) {
      valid = false;
      phoneNumberError.phoneNumberLength = true;
    }
    if (valid) {
      return null;
    } else {
      return { phoneNumber: phoneNumberError };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/update-profile/validators/masked-phone-number-validator.ts